module.exports = __webpack_public_path__ + "img/Loading_akkodis_logo_1.0d229b55.svg";